var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',[_c('navbar',{attrs:{"text":_vm.$t('Utilities.nutrition')}}),_vm._v(" "),_c('nutrition-plan-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }